import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import UtilFunctions from './UtilFunctions';
import './css/homesearch.css';
import './css/faq.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import serviceauth from './auth/serviceauth';
import isEmpty from 'lodash.isempty';

import Background from './images/class-search-background.png';
import '@fortawesome/fontawesome-free/css/all.css';
import { Link, withRouter } from 'react-router-dom';
import queryString from 'query-string';

// const entities = require('entities');
import XMLParser from 'react-xml-parser';

const jumbotronBackground = {
  backgroundPosition: '0% 68%',
  backgroundSize: 'cover',
  background:
    'linear-gradient(to top, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0)), url(' +
    Background +
    ')',
};

class ClassMaterials extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keywords: '',
      navTree: [],
      turnOffApp: false,
      width: window.innerWidth,
      height: window.innerHeight,
      activeTab: '',
      navItems: [],
      books: null,
      term: null,
      searchParams: null,
    };

    this.handleNavClick = this.handleNavClick.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  handleNavClick = (tabId) => {
    // console.log('handleNavClick(): ', tabId);
    this.setState({ activeTab: tabId });
  };

  async componentDidMount() {
    window.document.title =
      'Class Search | Course Materials | Arizona State University';
    let xml = null;
    window.addEventListener('resize', this.handleResize);

    // This is the full page view, so we need the main header defined
    // const appSettings = await UtilFunctions.getAppSettings()
    fetch(serviceauth.getRequestObject(UtilFunctions.getTermListUrl(), 'GET'))
      .then((response) => {
        if (response.status === 401) {
          serviceauth.reauth();
        }
        return response.json();
      })
      .then(async (termList) => {
        //update fields from url
        const data = UtilFunctions.parseUrl(this.props.location.search);
        const term = isEmpty(data.term)
          ? termList.currentTerm[0].value
          : data.term;
        this.setState({
          term: term,
          navTree: await UtilFunctions.getHeaderNavTree(term, 'faq'),
        });
      });

    // TEST params incoming
    const searchParams = queryString.parse(this.props.location.search);
    this.setState({ searchParams: searchParams });

    // Query book API for book list
    let url =
      UtilFunctions.getBookstoreURL() +
      encodeURI(UtilFunctions.getBookstoreURLHOST()) +
      '&method=bookstore.getBooks&slns=' +
      searchParams.classNum +
      '&strms=' +
      searchParams.classStrm;
    try {
      fetch(url)
        .then((response) => response.text())
        .then((book) => {
          xml = new XMLParser().parseFromString(book);

          // Determine activeTab from parsed xml directly (not from state)
          // to avoid React 18 batching race condition with setState
          let initialTab = '';
          if (xml?.getElementsByTagName('bookshelf')?.length > 0) {
            const booksRoot = xml.getElementsByTagName('bookshelf')[0];
            const navDefs = [
              { tag: 'requiredBooks', id: 'requiredBooks' },
              { tag: 'bookChoices', id: 'bookChoices' },
              { tag: 'recommendedBooks', id: 'recommendedBooks' },
            ];

            for (const { tag, id } of navDefs) {
              const el = booksRoot.getElementsByTagName(tag)?.[0];
              if (el?.children?.length > 0) {
                initialTab = id;
                break;
              }
            }
          }

          this.setState({
            books: xml,
            activeTab: initialTab,
          });
        })
        .catch((error) => {
          // no-dd-sa:javascript-best-practices/no-console
          console.error('Error fetching book data:', error);
        });
    } catch (error) {
      // no-dd-sa:javascript-best-practices/no-console
      console.error(error);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }

  // checkLandscape(width, height) {
  //   return width > height;
  // }

  backToDetails = (e) => {
    e.preventDefault();
    this.props.history.goBack();
  };

  // Copied from ClassDetails
  formatAmount(nbr) {
    let formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    return formatter.format(nbr);
  }

  // Create attribute detail to render next to book image
  // Attributes are NOT guaranteed to be present in XML! See lab items
  bookAttributes(bookObj) {
    return (
      <div className="col">
        {bookObj?.attributes?.title !== undefined && (
          <div className="row">
            <span className="fs-6">
              <span className="font-weight-bold">Title:</span>{' '}
              {UtilFunctions.decodeHtml(bookObj.attributes.title)}
            </span>
          </div>
        )}
        {bookObj?.attributes?.item !== undefined && (
          <div className="row">
            <span className="fs-6">
              <span className="font-weight-bold">Title:</span>{' '}
              {UtilFunctions.decodeHtml(bookObj.attributes.item)}
            </span>
          </div>
        )}
        {bookObj?.attributes?.author !== undefined && (
          <div className="row">
            <span className="fs-6">
              <span className="font-weight-bold">Author:</span>{' '}
              {UtilFunctions.decodeHtml(bookObj.attributes.author)}
            </span>
          </div>
        )}
        {bookObj?.attributes?.edition !== undefined && (
          <div className="row">
            <span className="fs-6">
              <span className="font-weight-bold">Edition:</span>{' '}
              {bookObj.attributes.edition}
            </span>
          </div>
        )}
        {bookObj?.attributes?.copyrightYear !== undefined && (
          <div className="row">
            <span className="fs-6">
              <span className="font-weight-bold">Copyright Year:</span>{' '}
              {bookObj.attributes.copyrightYear}
            </span>
          </div>
        )}
        {bookObj?.attributes?.publisher !== undefined && (
          <div className="row">
            <span className="fs-6">
              <span className="font-weight-bold">Publisher:</span>{' '}
              {UtilFunctions.decodeHtml(bookObj.attributes.publisher)}
            </span>
          </div>
        )}
        {bookObj?.attributes?.format !== undefined && (
          <div className="row">
            <span className="fs-6">
              <span className="font-weight-bold">Format:</span>{' '}
              {bookObj.attributes.format}
            </span>
          </div>
        )}
        {bookObj?.attributes?.isbn !== undefined && (
          <div className="row">
            <span className="fs-6">
              <span className="font-weight-bold">ISBN:</span>{' '}
              {bookObj.attributes.isbn}
            </span>
          </div>
        )}
        {bookObj?.attributes?.newPrice !== undefined && (
          <div className="row">
            <span className="fs-6">
              <span className="font-weight-bold">Price New:</span>{' '}
              {this.formatAmount(bookObj.attributes.newPrice)}
            </span>
          </div>
        )}
        {bookObj?.attributes?.usedPrice !== undefined && (
          <div className="row">
            <span className="fs-6">
              <span className="font-weight-bold">Price Used:</span>{' '}
              {this.formatAmount(bookObj.attributes.usedPrice)}
            </span>
          </div>
        )}
        {bookObj?.attributes?.rentalNewPrice !== undefined && (
          <div className="row">
            <span className="fs-6">
              <span className="font-weight-bold">Rental Price New:</span>{' '}
              {this.formatAmount(bookObj.attributes.rentalNewPrice)}
            </span>
          </div>
        )}
        {bookObj?.attributes?.rentalUsedPrice !== undefined && (
          <div className="row">
            <span className="fs-6">
              <span className="font-weight-bold">Rental Price Used:</span>{' '}
              {this.formatAmount(bookObj.attributes.rentalUsedPrice)}
            </span>
          </div>
        )}
        {bookObj?.attributes?.digitalRentalPrice !== undefined && (
          <div className="row">
            <span className="fs-6">
              <span className="font-weight-bold">Digital Rental Price:</span>{' '}
              {this.formatAmount(bookObj.attributes.digitalRentalPrice)}
            </span>
          </div>
        )}
        {bookObj?.attributes?.digitalPrice !== undefined && (
          <div className="row">
            <span className="fs-6">
              <span className="font-weight-bold">Digital Price:</span>{' '}
              {this.formatAmount(bookObj.attributes.digitalPrice)}
            </span>
          </div>
        )}
      </div>
    );
  }

  // Need to create one row, two columns, for book display
  // booksArray = bookChoices[0].children
  renderRows(booksArray) {
    let localBooksArray = booksArray;
    const bookRows = [];

    // if bookChoice value is found, we are doing choice books
    if (booksArray[0]?.name === 'bookChoice') {
      localBooksArray = booksArray[0].children;
    }

    for (let i = 0; i < localBooksArray.length; i += 2) {
      const bookOne = localBooksArray[i];
      const bookTwo = localBooksArray[i + 1];

      // create double column view when a second book is present
      bookRows.push(
        <Row key={i} className="pt-3 mb-4 align-items-start">
          {/* Book One */}
          <Col lg={2} md={3} sm={4} xs={12}>
            <img
              src={bookOne.attributes.imageUrl}
              alt="book cover"
              className="img-fluid"
              style={{ objectFit: 'fill', width: '188px', height: '234px' }}
            />
            <div className="mt-1">
              {UtilFunctions.materialType(bookOne).map((bookType, idx) => (
                <div
                  key={`${bookType}-${idx}`}
                  className="btn btn-sm btn-gray btn-tag disabled me-1 mb-1 mt-0"
                  style={{
                    color: 'black',
                    opacity: 1,
                    cursor: 'not-allowed',
                  }}
                >
                  {bookType}
                </div>
              ))}
            </div>
          </Col>

          <Col lg={4} md={9} sm={8} xs={12}>
            <div className="text-start ps-0 book-text-sm">
              {this.bookAttributes(bookOne)}
            </div>
          </Col>

          {/* Book Two (if available) */}
          {bookTwo && (
            <>
              <Col lg={2} md={3} sm={4} xs={12} className="mt-3 mt-md-0">
                <img
                  src={bookTwo.attributes.imageUrl}
                  alt="book cover"
                  className="img-fluid"
                  style={{ objectFit: 'fill', width: '188px', height: '234px' }}
                />
                <div className="mt-1">
                  {UtilFunctions.materialType(bookTwo).map((bookType, idx) => (
                    <div
                      key={`${bookType}-${idx}`}
                      className="btn btn-sm btn-gray btn-tag disabled me-1 mb-1 mt-0"
                      style={{
                        color: 'black',
                        opacity: 1,
                        cursor: 'not-allowed',
                      }}
                    >
                      {bookType}
                    </div>
                  ))}
                </div>
              </Col>

              <Col lg={4} md={9} sm={8} xs={12} className="mt-3 mt-md-0">
                <div className="text-start ps-0 book-text-sm">
                  {this.bookAttributes(bookTwo)}
                </div>
              </Col>
            </>
          )}
        </Row>
      );
    }

    return bookRows;
  }

  bookshelf(books) {
    let output = [];
    let adoptionMessage = false;

    for (let index = 0; index < books.length; index++) {
      const bookshelf = books[index]; // single item in the array is returned [ {// book stuff} ]
      if (bookshelf.attributes.includED === 'Y') {
        output.push(
          <Row className="">
            <Col className="col-lg-6 col-md-10 col-sm-4">
              <span className="font-weight-bold">
                Inclusive Access Program for Course Materials
              </span>
              <p>
                This course is participating in{' '}
                <a
                  href="https://asu.my.salesforce-sites.com/kb/articles/FAQ/ASU-s-Inclusive-Access-Program"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Visit Inclusive Access FAQ in a new tab"
                >
                  ASU's Inclusive Access program.
                </a>{' '}
                Required digital course materials will be provisioned through
                Canvas and the associated cost automatically charged at a
                discounted price to your student account. Charges will be
                visible in your My ASU Finances tab (under the description
                Digital Integrated Course Mtrl) approx. 1 month after classes
                start.
              </p>
            </Col>
          </Row>
        );
      }

      if (
        bookshelf.attributes.adoptionMessage === '' ||
        bookshelf.attributes.adoptionMessage === 'NoBooksRequired'
      ) {
        adoptionMessage = true;
        output.push(
          <Row className="pt-2">
            <Col>
              <p className="font-italic">
                No ASU Bookstore materials required. Refer to syllabus for
                additional details.
              </p>
            </Col>
          </Row>
        );
      }
    }

    // create navbar header
    const booksRoot = books[0];
    const navDefs = [
      { tag: 'requiredBooks', id: 'requiredBooks', label: 'Required' },
      { tag: 'bookChoices', id: 'bookChoices', label: 'Selection required' },
      { tag: 'recommendedBooks', id: 'recommendedBooks', label: 'Recommended' },
    ];

    // build header nav, loop my nav defs, for each if there is a child, add to array and return
    const navItems = navDefs.reduce((acc, { tag, id, label }) => {
      const el = booksRoot.getElementsByTagName(tag)?.[0];
      if (el?.children?.length > 0) {
        acc.push({ id, label });
      }
      return acc;
    }, []);

    const requiredBooks = books[0].getElementsByTagName('requiredBooks');
    const bookChoices = books[0].getElementsByTagName('bookChoices');
    const recommendedBooks = books[0].getElementsByTagName('recommendedBooks');

    output.push(
      <>
        <div className="container navbar mb-0 pb-0">
          <ul className="nav nav-tabs">
            {navItems.map((naviItem) => (
              <li className="nav-item" key={naviItem.id}>
                <button
                  className={`nav-link ${
                    this.state.activeTab === naviItem.id
                      ? 'book-tab-active'
                      : 'underline-on-hover '
                  }`}
                  onClick={() => this.handleNavClick(naviItem.id)}
                  style={{ color: 'black' }}
                >
                  {naviItem.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <hr className="mt-0 pt-0 mb-3" />
      </>
    );

    if (
      !adoptionMessage &&
      requiredBooks[0]?.children?.length === 0 &&
      recommendedBooks[0]?.children?.length === 0 &&
      bookChoices[0]?.children?.length === 0
    ) {
      output.push(
        <Row className="pt-2">
          <Col>
            <p className="font-italic">
              Not yet provided by instructor. Refer to syllabus for additional
              details.
            </p>
          </Col>
        </Row>
      );
    } else {
      if (this.state.activeTab === 'requiredBooks') {
        output.push(
          <>
            <Row className="ps-0 fw-bold fs-5">
              {/* <span>Required materials</span> */}
            </Row>
            {this.renderRows(requiredBooks[0].children)}
          </>
        );
      }

      if (this.state.activeTab === 'bookChoices') {
        output.push(
          <>
            <Row className="ps-0 fw-bold fs-5">
              <span>
                Choose{' '}
                {bookChoices[0].children[0]?.attributes?.selectionQuantity ||
                  '1'}{' '}
                of {bookChoices[0].children[0]?.children?.length || 'several'}{' '}
                materials below:
              </span>
            </Row>
            {this.renderRows(bookChoices[0].children)}
          </>
        );
      }

      if (this.state.activeTab === 'recommendedBooks') {
        output.push(
          <>
            <Row className="ps-0 fw-bold fs-5">
              {/* <span>Recommended materials</span> */}
            </Row>
            {this.renderRows(recommendedBooks[0].children)}
          </>
        );
      }
    }

    return output;
  }

  render() {
    let books = null;
    if (this.state.books != null) {
      books = this.state.books.getElementsByTagName('bookshelf');
    } else {
      return <div></div>;
    }

    const term = UtilFunctions.getStringFromTermcode(
      queryString.parse(this.props.location.search).classStrm
    );
    const classNum = queryString.parse(this.props.location.search).classNum;
    const subject = queryString.parse(this.props.location.search).subject;
    const catalogNbr = queryString.parse(this.props.location.search).catalogNbr;
    const cameFrom = this.props.location.state?.from || 'unknown';

    return (
      <React.Fragment>
        <Container fluid={true} className="p-0">
          <Header navTree={this.state.navTree} />
          <section
            style={jumbotronBackground}
            className="mb-0 pt-10 pb-10"
            id="main"
            aria-label="Class materials page"
          >
            <Container>
              <Row>
                <Col xs={'auto'} className="p-0">
                  <h1 className="mt-0" id="skip-to-content">
                    <span className="highlight-white">Class Search</span>
                  </h1>
                </Col>
              </Row>
            </Container>
          </section>

          {/* After Header Menu */}
          <div className="container">
            <div className="row row-spaced pt-2 pb-2">
              <div className="col col-12 col-md-12 col-lg-12">
                <div className="container-fluid pr-0 pl-0">
                  <Container className="pb-1 mb-5 ps-0 pe-0">
                    <Row>
                      {cameFrom === 'ClassDetails' ? (
                        <button
                          className="button-link d-flex ms-1"
                          onClick={this.backToDetails}
                        >
                          ← Return to results page
                        </button>
                      ) : (
                        <Link
                          to={`/catalog/classes/classlist?${getBackToSearchUrl(
                            this.props,
                            classNum
                          )}`}
                        >
                          <button className="button-link d-flex ms-1">
                            ← Return to results page
                          </button>
                        </Link>
                      )}
                    </Row>
                    <div className="row">
                      <div className="">
                        <p className="bigTitle mb-4 mt-1">
                          {subject} {catalogNbr} Course Materials ({term}, Class
                          #{classNum})
                        </p>

                        {books !== null && books.length > 0 && (
                          <div className="col col-sm-12">
                            <div>{this.bookshelf(books)}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </Container>
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </Container>
      </React.Fragment>
    );
  }
}

export default withRouter(ClassMaterials);

function getBackToSearchUrl(props, classNum) {
  let url = UtilFunctions.getQueryString({
    keywords: classNum,
    promod: 'F',
    searchType: 'all',
    term: queryString.parse(props.location.search).classStrm,
  });

  let detailsOpen = queryString.parse(props.location.search).detailsOpen;

  return `${url}#detailsOpen=${detailsOpen}`; // Append detailsOpen to the URL to open drawer
}
